// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

/************************************************
   Generated with the Devware CAP CLI 4.4.22
   Code Gen Name   PayJobChange
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MLT-MSI/mlt
   Generate On     3/20/2023 12:25:14 PM
************************************************/

export enum PayJobChangeMetaDataItemNames {
    DWPeoplePayHistory = 'DW_PeoplePayHistory',
    DWPeoplePaySummary = 'DW_PeoplePaySummary',
    EthosJob = 'Ethos_Job',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobSite = 'Ethos_JobSite',
    EthosJobSow = 'Ethos_JobSow',
    EthosWachterJobTitle = 'Ethos_WachterJobTitle',
    FieldEmployeesPayRate = 'FieldEmployeesPayRate',
    PayJobChange = 'PayJobChange',
    PayJobChangeEmail = 'PayJobChangeEmail',
    PayJobChangeUsersRead = 'PayJobChangeUsersRead',
    RoPayJobChangeSubordinates = 'roPayJobChangeSubordinates',
}

export enum PayJobChangeMetaDataLookups {
    DWPeoplePayHistoryAllItems = 1624,
    DWPeoplePaySummaryAllItems = 1791,
    EthosJobAllItems = 1716,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobSiteAllItems = 1717,
    EthosJobSowAllItems = 1718,
    EthosWachterJobTitleAllItems = 1387,
    FieldEmployeesPayRateAllItems = 1555,
    JobByOpportunityId = 1794,
    JobLookupWithJobNumber = 1729,
    JobSiteSiteInfo = 1788,
    JobSowScopeOfWorkAndSiteInfo = 1725,
    OverheadJobNumbers = 1589,
    PayJobChangeAllItems = 1478,
    PayJobChangeEmailAllItems = 1484,
    PayJobChangeUsersReadAllItems = 1483,
    RoPayJobChangeSubordinatesAllItems = 1770,
    WJIDByJobNumber = 1871,
}

@Injectable({
    providedIn: 'root'
})
export class PayJobChangeMetaDataService {

    DWPeoplePayHistory : DWPeoplePayHistory = new DWPeoplePayHistory();
    DWPeoplePaySummary : DWPeoplePaySummary = new DWPeoplePaySummary();
    EthosJob : EthosJob = new EthosJob();
    EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    EthosJobSite : EthosJobSite = new EthosJobSite();
    EthosJobSow : EthosJobSow = new EthosJobSow();
    EthosWachterJobTitle : EthosWachterJobTitle = new EthosWachterJobTitle();
    FieldEmployeesPayRate : FieldEmployeesPayRate = new FieldEmployeesPayRate();
    PayJobChange : PayJobChange = new PayJobChange();
    PayJobChangeEmail : PayJobChangeEmail = new PayJobChangeEmail();
    PayJobChangeUsersRead : PayJobChangeUsersRead = new PayJobChangeUsersRead();
    RoPayJobChangeSubordinates : RoPayJobChangeSubordinates = new RoPayJobChangeSubordinates();
}

// Generated Classes for MetaData service
class DWPeoplePayHistory implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_PeoplePayHistory.';

    constructor() {
        this.ItemDetail.ItemId=2573;
        this.ItemDetail.ItemName='DW_PeoplePayHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PPHId : string = this.i + 'PPHId';
    PersonId : string = this.i + 'PersonId';
    ETHOSUserId : string = this.i + 'ETHOSUserId';
    ETHOSBridgeUserId : string = this.i + 'ETHOSBridgeUserId';
    ETHOSLoginId : string = this.i + 'ETHOSLoginId';
    AXPersonnelNo : string = this.i + 'AXPersonnelNo';
    AXWorkerNo : string = this.i + 'AXWorkerNo';
    Section01 : string = this.i + 'Section_01';
    Person : string = this.i + 'Person';
    PersonLong : string = this.i + 'PersonLong';
    LastNameFirst : string = this.i + 'LastNameFirst';
    LastNameFirstPreferred : string = this.i + 'LastNameFirstPreferred';
    FirstName : string = this.i + 'FirstName';
    MiddleName : string = this.i + 'MiddleName';
    LastName : string = this.i + 'LastName';
    PreferredName : string = this.i + 'PreferredName';
    EffectiveUserName : string = this.i + 'EffectiveUserName';
    Email : string = this.i + 'Email';
    JobTitle : string = this.i + 'JobTitle';
    PersonwJobTitle : string = this.i + 'PersonwJobTitle';
    Section02 : string = this.i + 'Section_02';
    HireDate : string = this.i + 'HireDate';
    YrsService : string = this.i + 'YrsService';
    StartDate : string = this.i + 'StartDate';
    ServiceDate : string = this.i + 'ServiceDate';
    TermDate : string = this.i + 'TermDate';
    Section03 : string = this.i + 'Section_03';
    SupervisorId : string = this.i + 'SupervisorId';
    SupETHOSUserId : string = this.i + 'SupETHOSUserId';
    Supervisor : string = this.i + 'Supervisor';
    SupervisorwJobTitle : string = this.i + 'SupervisorwJobTitle';
    Section04 : string = this.i + 'Section_04';
    PeopleTeamCode : string = this.i + 'PeopleTeamCode';
    PeopleTeam : string = this.i + 'PeopleTeam';
    PeopleTeamLong : string = this.i + 'PeopleTeamLong';
    PeopleTeamMethod : string = this.i + 'PeopleTeamMethod';
    PeopleDepartmentCode : string = this.i + 'PeopleDepartmentCode';
    PeopleDepartment : string = this.i + 'PeopleDepartment';
    PeopleDepartmentLong : string = this.i + 'PeopleDepartmentLong';
    PeopleDivisionCode : string = this.i + 'PeopleDivisionCode';
    PeopleDivision : string = this.i + 'PeopleDivision';
    PeopleDivisionLong : string = this.i + 'PeopleDivisionLong';
    PeopleBusinessCode : string = this.i + 'PeopleBusinessCode';
    PeopleBusiness : string = this.i + 'PeopleBusiness';
    PeopleBusinessLong : string = this.i + 'PeopleBusinessLong';
    PeopleGroupCode : string = this.i + 'PeopleGroupCode';
    PeopleGroup : string = this.i + 'PeopleGroup';
    PeopleGroupLong : string = this.i + 'PeopleGroupLong';
    Section05 : string = this.i + 'Section_05';
    PersonExemptStatus : string = this.i + 'PersonExemptStatus';
    PersonGroup : string = this.i + 'PersonGroup';
    PersonGroupParent : string = this.i + 'PersonGroupParent';
    PersonStaffingAgency : string = this.i + 'PersonStaffingAgency';
    PersonStatus : string = this.i + 'PersonStatus';
    PersonType : string = this.i + 'PersonType';
    Office : string = this.i + 'Office';
    Section06 : string = this.i + 'Section_06';
    HasHours : string = this.i + 'HasHours';
    HasJobTitle : string = this.i + 'HasJobTitle';
    HasSkillComm : string = this.i + 'HasSkillComm';
    HasSkillElectrical : string = this.i + 'HasSkillElectrical';
    HasSkillSecurity : string = this.i + 'HasSkillSecurity';
    HasValidSupervisor : string = this.i + 'HasValidSupervisor';
    HasValidTeam : string = this.i + 'HasValidTeam';
    IsActive : string = this.i + 'IsActive';
    IsEngineer : string = this.i + 'IsEngineer';
    IsTerminated : string = this.i + 'IsTerminated';
    IsWachterEmp : string = this.i + 'IsWachterEmp';
    SupForcedAssign : string = this.i + 'SupForcedAssign';
    Section07 : string = this.i + 'Section_07';
    Action : string = this.i + 'Action';
    EffectiveDate : string = this.i + 'EffectiveDate';
    MonthIdALT : string = this.i + 'MonthIdALT';
    Period : string = this.i + 'Period';
    Year : string = this.i + 'Year';
    DataAreaId : string = this.i + 'DataAreaId';
    PayRateProcessType : string = this.i + 'PayRateProcessType';
    PayRateStatus : string = this.i + 'PayRateStatus';
    RowNum : string = this.i + 'RowNum';
    PayRate : string = this.i + 'PayRate';

    Relations = {
    };
}

class DWPeoplePaySummary implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'DW_PeoplePaySummary.';

    constructor() {
        this.ItemDetail.ItemId=2692;
        this.ItemDetail.ItemName='DW_PeoplePaySummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PPSId : string = this.i + 'PPSId';
    PersonId : string = this.i + 'PersonId';
    ETHOSUserId : string = this.i + 'ETHOSUserId';
    ETHOSOtherUserId : string = this.i + 'ETHOSOtherUserId';
    ETHOSLoginId : string = this.i + 'ETHOSLoginId';
    AXPersonnelNo : string = this.i + 'AXPersonnelNo';
    AXWorkerNo : string = this.i + 'AXWorkerNo';
    SectionPERSON : string = this.i + 'Section_PERSON';
    Person : string = this.i + 'Person';
    PersonLong : string = this.i + 'PersonLong';
    LastNameFirst : string = this.i + 'LastNameFirst';
    LastNameFirstPreferred : string = this.i + 'LastNameFirstPreferred';
    FirstName : string = this.i + 'FirstName';
    MiddleName : string = this.i + 'MiddleName';
    LastName : string = this.i + 'LastName';
    PreferredName : string = this.i + 'PreferredName';
    EffectiveUserName : string = this.i + 'EffectiveUserName';
    Email : string = this.i + 'Email';
    JobTitle : string = this.i + 'JobTitle';
    PersonwJobTitle : string = this.i + 'PersonwJobTitle';
    SectionTIME : string = this.i + 'Section_TIME';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDateNoYr : string = this.i + 'BirthDateNoYr';
    HireDate : string = this.i + 'HireDate';
    YrsService : string = this.i + 'YrsService';
    StartDate : string = this.i + 'StartDate';
    AdjStartDate : string = this.i + 'AdjStartDate';
    ServiceDate : string = this.i + 'ServiceDate';
    ServiceAwardMonth : string = this.i + 'ServiceAwardMonth';
    TermDate : string = this.i + 'TermDate';
    ReportDate : string = this.i + 'ReportDate';
    SectionSUPERVISOR : string = this.i + 'Section_SUPERVISOR';
    SupervisorId : string = this.i + 'SupervisorId';
    SupETHOSUserId : string = this.i + 'SupETHOSUserId';
    Supervisor : string = this.i + 'Supervisor';
    SupervisorwJobTitle : string = this.i + 'SupervisorwJobTitle';
    SectionDIMENSIONs : string = this.i + 'Section_DIMENSIONs';
    GroupCode : string = this.i + 'GroupCode';
    Group : string = this.i + 'Group';
    GroupParent : string = this.i + 'GroupParent';
    JobFunctionCode : string = this.i + 'JobFunctionCode';
    JobFunction : string = this.i + 'JobFunction';
    Office : string = this.i + 'Office';
    ExemptStatus : string = this.i + 'ExemptStatus';
    StaffingAgency : string = this.i + 'StaffingAgency';
    Status : string = this.i + 'Status';
    Type : string = this.i + 'Type';
    TypeGroup : string = this.i + 'TypeGroup';
    SectionWACHTERORG : string = this.i + 'Section_WACHTERORG';
    PeopleTeamCode : string = this.i + 'PeopleTeamCode';
    PeopleTeam : string = this.i + 'PeopleTeam';
    PeopleTeamLong : string = this.i + 'PeopleTeamLong';
    PeopleTeamMethod : string = this.i + 'PeopleTeamMethod';
    PeopleDepartmentCode : string = this.i + 'PeopleDepartmentCode';
    PeopleDepartment : string = this.i + 'PeopleDepartment';
    PeopleDepartmentLong : string = this.i + 'PeopleDepartmentLong';
    PeopleDivisionCode : string = this.i + 'PeopleDivisionCode';
    PeopleDivision : string = this.i + 'PeopleDivision';
    PeopleDivisionLong : string = this.i + 'PeopleDivisionLong';
    PeopleBusinessCode : string = this.i + 'PeopleBusinessCode';
    PeopleBusiness : string = this.i + 'PeopleBusiness';
    PeopleBusinessLong : string = this.i + 'PeopleBusinessLong';
    PeopleGroupCode : string = this.i + 'PeopleGroupCode';
    PeopleGroup : string = this.i + 'PeopleGroup';
    PeopleGroupLong : string = this.i + 'PeopleGroupLong';
    SectionFLAGs : string = this.i + 'Section_FLAGs';
    HasHours : string = this.i + 'HasHours';
    HasJobTitle : string = this.i + 'HasJobTitle';
    HasSkillComm : string = this.i + 'HasSkillComm';
    HasSkillElectrical : string = this.i + 'HasSkillElectrical';
    HasSkillSecurity : string = this.i + 'HasSkillSecurity';
    HasValidSupervisor : string = this.i + 'HasValidSupervisor';
    HasValidTeam : string = this.i + 'HasValidTeam';
    IsActive : string = this.i + 'IsActive';
    IsEngineer : string = this.i + 'IsEngineer';
    IsTerminated : string = this.i + 'IsTerminated';
    IsWachterEmp : string = this.i + 'IsWachterEmp';
    SupForcedAssign : string = this.i + 'SupForcedAssign';
    SectionAMOUNTs : string = this.i + 'Section_AMOUNTs';
    PayRate : string = this.i + 'PayRate';
    PayRateCur : string = this.i + 'PayRate_cur';
    PayRateCurDate : string = this.i + 'PayRate_cur_Date';
    PayRateLast : string = this.i + 'PayRate_last';
    PayRateLastDate : string = this.i + 'PayRate_last_Date';
    PayRateFirst : string = this.i + 'PayRate_first';
    PayRateFirstDate : string = this.i + 'PayRate_first_Date';
    SinceLastRateChgDate : string = this.i + 'SinceLast_RateChg_Date';
    SinceLastRateChg : string = this.i + 'SinceLast_RateChg';
    SinceLastRateChgText : string = this.i + 'SinceLast_RateChg_Text';
    BurdenRate : string = this.i + 'BurdenRate';
    BurdenRateCur : string = this.i + 'BurdenRate_cur';
    BurdenRateCurDate : string = this.i + 'BurdenRate_cur_Date';
    BurdenRateLast : string = this.i + 'BurdenRate_last';
    BurdenRateLastDate : string = this.i + 'BurdenRate_last_Date';
    BurdenRateFirst : string = this.i + 'BurdenRate_first';
    BurdenRateFirstDate : string = this.i + 'BurdenRate_first_Date';
    BillRate : string = this.i + 'BillRate';
    BillRateCur : string = this.i + 'BillRate_cur';
    BillRateCurDate : string = this.i + 'BillRate_cur_Date';
    BillRateLast : string = this.i + 'BillRate_last';
    BillRateLastDate : string = this.i + 'BillRate_last_Date';
    BillRateFirst : string = this.i + 'BillRate_first';
    BillRateFirstDate : string = this.i + 'BillRate_first_Date';

    Relations = {
    };
}

class EthosJob implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_Job.';

    constructor() {
        this.ItemDetail.ItemId=2635;
        this.ItemDetail.ItemName='Ethos_Job';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobId : string = this.i + 'JobId';
    JobNumberId : string = this.i + 'JobNumberId';
    JobEtcDateTime : string = this.i + 'JobEtcDateTime';

    Relations = {
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Ethos Job Site */
            EthosJobSiteByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobSiteJobId',
                PropertyName: 'EthosJobSiteJobId'
            },
            /** Relation: Job Number */
            EthosJobNumberByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobNumberJobNumberId',
                PropertyName: 'EthosJobNumberJobNumberId'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
    };
}

class EthosJobNumber implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';

    Relations = {
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_JobNumber|Ethos_Job|JobNumberId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
            /** Relation: Ethos Job */
            EthosJobByJobNumberId : {
                RelationName: 'JobToJobNumber',
                FieldPrefix: 'EthosJobJobNumberId',
                PropertyName: 'EthosJobJobNumberId'
            },
    };
}

class EthosJobNumberForecast implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';

    Relations = {
    };
}

class EthosJobNumberPhase implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';

    Relations = {
    };
}

class EthosJobSite implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSite.';

    constructor() {
        this.ItemDetail.ItemId=2636;
        this.ItemDetail.ItemName='Ethos_JobSite';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSiteId : string = this.i + 'JobSiteId';
    JobId : string = this.i + 'JobId';
    SiteId : string = this.i + 'SiteId';
    IsDeleted : string = this.i + 'IsDeleted';
    LookUpKey : string = this.i + 'LookUpKey';
    SubJobNumber : string = this.i + 'SubJobNumber';
    FullJobNumber : string = this.i + 'FullJobNumber';

    Relations = {
            /** Relation: Ethos Job Sow */
            EthosJobSow : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSow',
                PropertyName: 'EthosJobSow'
            },
            /** Relation: Ethos Job */
            EthosJobByJobId : {
                RelationName: 'Job Site -> Job',
                FieldPrefix: 'EthosJobJobId',
                PropertyName: 'EthosJobJobId'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSite|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

class EthosJobSow implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobSow.';

    constructor() {
        this.ItemDetail.ItemId=2637;
        this.ItemDetail.ItemName='Ethos_JobSow';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobSowId : string = this.i + 'JobSowId';
    SowId : string = this.i + 'SowId';
    JobId : string = this.i + 'JobId';
    JobSiteId : string = this.i + 'JobSiteId';

    Relations = {
            /** Relation: Ethos Job Site */
            EthosJobSite : {
                RelationName: 'Ethos_JobSite|Ethos_JobSow|JobSiteId',
                FieldPrefix: 'EthosJobSite',
                PropertyName: 'EthosJobSite'
            },
            /** Relation: Ethos Job */
            EthosJob : {
                RelationName: 'Ethos_Job|Ethos_JobSow|JobId',
                FieldPrefix: 'EthosJob',
                PropertyName: 'EthosJob'
            },
    };
}

class EthosWachterJobTitle implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterJobTitle.';

    constructor() {
        this.ItemDetail.ItemId=2384;
        this.ItemDetail.ItemName='Ethos_WachterJobTitle';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    WachterJobTitleDescription : string = this.i + 'WachterJobTitleDescription';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: PAF Pay/Job Change - New Job Title - Many */
            PayJobChangeByNewJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|PayJobChange|NewJobTitleId',
                FieldPrefix: 'NewJobTitleIdPayJobChange',
                PropertyName: 'NewJobTitleIdPayJobChange'
            },
    };
}

class FieldEmployeesPayRate implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'FieldEmployeesPayRate.';

    constructor() {
        this.ItemDetail.ItemId=2522;
        this.ItemDetail.ItemName='FieldEmployeesPayRate';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    PayRate : string = this.i + 'PayRate';
    Company : string = this.i + 'Company';

    Relations = {
    };
}

class PayJobChange implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChange.';

    constructor() {
        this.ItemDetail.ItemId=2469;
        this.ItemDetail.ItemName='PayJobChange';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    EffectiveDate : string = this.i + 'EffectiveDate';
    CurrentWage : string = this.i + 'CurrentWage';
    NewWage : string = this.i + 'NewWage';
    Notes : string = this.i + 'Notes';
    IsPayChange : string = this.i + 'IsPayChange';
    IsOrganizationalChange : string = this.i + 'IsOrganizationalChange';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    NewManagerEthosUserId : string = this.i + 'NewManagerEthos_UserId';
    PayChangeTypeCv : string = this.i + 'PayChangeTypeCv';
    StatusCv : string = this.i + 'StatusCv';
    StatusAssignedToEthosUserId : string = this.i + 'StatusAssignedToEthos_UserId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    NewJobTitleId : string = this.i + 'NewJobTitleId';
    WagePercentChange : string = this.i + 'WagePercentChange';
    NewEthosWachterTeamId : string = this.i + 'NewEthos_WachterTeamId';
    RejectedNotes : string = this.i + 'RejectedNotes';
    RejectedByEthosUserId : string = this.i + 'RejectedByEthos_UserId';

    Relations = {
            /** Relation: Pay Job Change Email */
            PayJobChangeEmail : {
                RelationName: 'PayJobChange|PayJobChangeEmail|PayJobChangeId',
                FieldPrefix: 'PayJobChangeEmail',
                PropertyName: 'PayJobChangeEmail'
            },
            /** Relation: Wachter Job Title - New Job Title */
            EthosWachterJobTitleByNewJobTitleId : {
                RelationName: 'Ethos_WachterJobTitle|PayJobChange|NewJobTitleId',
                FieldPrefix: 'NewJobTitleIdEthosWachterJobTitle',
                PropertyName: 'NewJobTitleIdEthosWachterJobTitle'
            },
            /** Relation: Pay Job Change Users Read */
            PayJobChangeUsersRead : {
                RelationName: 'PayJobChange|PayJobChangeUsersRead|PayJobChangeId',
                FieldPrefix: 'PayJobChangeUsersRead',
                PropertyName: 'PayJobChangeUsersRead'
            },
    };
}

class PayJobChangeEmail implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChangeEmail.';

    constructor() {
        this.ItemDetail.ItemId=2475;
        this.ItemDetail.ItemName='PayJobChangeEmail';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeEmail : string = this.i + 'PayJobChangeEmail';
    EmailId : string = this.i + 'EmailId';
    PayJobChangeId : string = this.i + 'PayJobChangeId';

    Relations = {
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'PayJobChange|PayJobChangeEmail|PayJobChangeId',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
    };
}

class PayJobChangeUsersRead implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'PayJobChangeUsersRead.';

    constructor() {
        this.ItemDetail.ItemId=2474;
        this.ItemDetail.ItemName='PayJobChangeUsersRead';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeUsersRead : string = this.i + 'PayJobChangeUsersRead';
    EthosUserId : string = this.i + 'Ethos_UserId';
    PayJobChangeId : string = this.i + 'PayJobChangeId';

    Relations = {
            /** Relation: PAF Pay/Job Change */
            PayJobChange : {
                RelationName: 'PayJobChange|PayJobChangeUsersRead|PayJobChangeId',
                FieldPrefix: 'PayJobChange',
                PropertyName: 'PayJobChange'
            },
    };
}

class RoPayJobChangeSubordinates implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roPayJobChangeSubordinates.';

    constructor() {
        this.ItemDetail.ItemId=2674;
        this.ItemDetail.ItemName='roPayJobChangeSubordinates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PayJobChangeId : string = this.i + 'PayJobChangeId';
    EmployeeEthosUserId : string = this.i + 'EmployeeEthos_UserId';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    EmployeeSupervisorUserId : string = this.i + 'EmployeeSupervisorUserId';
    EmployeeSupervisorName : string = this.i + 'EmployeeSupervisorName';
    EmployeeSupervisorDepth : string = this.i + 'EmployeeSupervisorDepth';
    CreatedBySupervisorUserId : string = this.i + 'CreatedBySupervisorUserId';
    CreatedBySupervisorName : string = this.i + 'CreatedBySupervisorName';
    CreatedBySupervisorDepth : string = this.i + 'CreatedBySupervisorDepth';

    Relations = {
    };
}


export class PayJobChangeMetaData {

    static DWPeoplePayHistory : DWPeoplePayHistory = new DWPeoplePayHistory();
    static DWPeoplePaySummary : DWPeoplePaySummary = new DWPeoplePaySummary();
    static EthosJob : EthosJob = new EthosJob();
    static EthosJobNumber : EthosJobNumber = new EthosJobNumber();
    static EthosJobNumberForecast : EthosJobNumberForecast = new EthosJobNumberForecast();
    static EthosJobNumberPhase : EthosJobNumberPhase = new EthosJobNumberPhase();
    static EthosJobSite : EthosJobSite = new EthosJobSite();
    static EthosJobSow : EthosJobSow = new EthosJobSow();
    static EthosWachterJobTitle : EthosWachterJobTitle = new EthosWachterJobTitle();
    static FieldEmployeesPayRate : FieldEmployeesPayRate = new FieldEmployeesPayRate();
    static PayJobChange : PayJobChange = new PayJobChange();
    static PayJobChangeEmail : PayJobChangeEmail = new PayJobChangeEmail();
    static PayJobChangeUsersRead : PayJobChangeUsersRead = new PayJobChangeUsersRead();
    static RoPayJobChangeSubordinates : RoPayJobChangeSubordinates = new RoPayJobChangeSubordinates();
}

// Generated Entity Interfaces
export interface DWPeoplePayHistoryEntity extends DwOrmData {
    // Attributes
    PPHId?: number;
    PersonId?: number;
    ETHOSUserId?: number;
    ETHOSBridgeUserId?: number;
    ETHOSLoginId?: string;
    AXPersonnelNo?: string;
    AXWorkerNo?: number;
    Section_01?: string;
    Person?: string;
    PersonLong?: string;
    LastNameFirst?: string;
    LastNameFirstPreferred?: string;
    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    PreferredName?: string;
    EffectiveUserName?: string;
    Email?: string;
    JobTitle?: string;
    PersonwJobTitle?: string;
    Section_02?: string;
    HireDate?: string;
    YrsService?: number;
    StartDate?: string;
    ServiceDate?: string;
    TermDate?: string;
    Section_03?: string;
    SupervisorId?: number;
    SupETHOSUserId?: number;
    Supervisor?: string;
    SupervisorwJobTitle?: string;
    Section_04?: string;
    PeopleTeamCode?: string;
    PeopleTeam?: string;
    PeopleTeamLong?: string;
    PeopleTeamMethod?: string;
    PeopleDepartmentCode?: string;
    PeopleDepartment?: string;
    PeopleDepartmentLong?: string;
    PeopleDivisionCode?: string;
    PeopleDivision?: string;
    PeopleDivisionLong?: string;
    PeopleBusinessCode?: string;
    PeopleBusiness?: string;
    PeopleBusinessLong?: string;
    PeopleGroupCode?: string;
    PeopleGroup?: string;
    PeopleGroupLong?: string;
    Section_05?: string;
    PersonExemptStatus?: string;
    PersonGroup?: string;
    PersonGroupParent?: string;
    PersonStaffingAgency?: string;
    PersonStatus?: string;
    PersonType?: string;
    Office?: string;
    Section_06?: string;
    HasHours?: boolean;
    HasJobTitle?: boolean;
    HasSkillComm?: boolean;
    HasSkillElectrical?: boolean;
    HasSkillSecurity?: boolean;
    HasValidSupervisor?: boolean;
    HasValidTeam?: boolean;
    IsActive?: boolean;
    IsEngineer?: boolean;
    IsTerminated?: boolean;
    IsWachterEmp?: boolean;
    SupForcedAssign?: boolean;
    Section_07?: string;
    Action?: string;
    EffectiveDate?: string;
    MonthIdALT?: number;
    Period?: string;
    Year?: number;
    DataAreaId?: string;
    PayRateProcessType?: string;
    PayRateStatus?: string;
    RowNum?: number;
    PayRate?: number;

    // Display Attributes
    ETHOSUserIdDisplay?: string;
    // Relations
}

export interface DWPeoplePaySummaryEntity extends DwOrmData {
    // Attributes
    PPSId?: number;
    PersonId?: number;
    ETHOSUserId?: number;
    ETHOSOtherUserId?: number;
    ETHOSLoginId?: string;
    AXPersonnelNo?: string;
    AXWorkerNo?: number;
    Section_PERSON?: string;
    Person?: string;
    PersonLong?: string;
    LastNameFirst?: string;
    LastNameFirstPreferred?: string;
    FirstName?: string;
    MiddleName?: string;
    LastName?: string;
    PreferredName?: string;
    EffectiveUserName?: string;
    Email?: string;
    JobTitle?: string;
    PersonwJobTitle?: string;
    Section_TIME?: string;
    BirthMonth?: string;
    BirthDateNoYr?: string;
    HireDate?: string;
    YrsService?: number;
    StartDate?: string;
    AdjStartDate?: string;
    ServiceDate?: string;
    ServiceAwardMonth?: string;
    TermDate?: string;
    ReportDate?: string;
    Section_SUPERVISOR?: string;
    SupervisorId?: number;
    SupETHOSUserId?: number;
    Supervisor?: string;
    SupervisorwJobTitle?: string;
    Section_DIMENSIONs?: string;
    GroupCode?: string;
    Group?: string;
    GroupParent?: string;
    JobFunctionCode?: string;
    JobFunction?: string;
    Office?: string;
    ExemptStatus?: string;
    StaffingAgency?: string;
    Status?: string;
    Type?: string;
    TypeGroup?: string;
    Section_WACHTERORG?: string;
    PeopleTeamCode?: string;
    PeopleTeam?: string;
    PeopleTeamLong?: string;
    PeopleTeamMethod?: string;
    PeopleDepartmentCode?: string;
    PeopleDepartment?: string;
    PeopleDepartmentLong?: string;
    PeopleDivisionCode?: string;
    PeopleDivision?: string;
    PeopleDivisionLong?: string;
    PeopleBusinessCode?: string;
    PeopleBusiness?: string;
    PeopleBusinessLong?: string;
    PeopleGroupCode?: string;
    PeopleGroup?: string;
    PeopleGroupLong?: string;
    Section_FLAGs?: string;
    HasHours?: boolean;
    HasJobTitle?: boolean;
    HasSkillComm?: boolean;
    HasSkillElectrical?: boolean;
    HasSkillSecurity?: boolean;
    HasValidSupervisor?: boolean;
    HasValidTeam?: boolean;
    IsActive?: boolean;
    IsEngineer?: boolean;
    IsTerminated?: boolean;
    IsWachterEmp?: boolean;
    SupForcedAssign?: boolean;
    Section_AMOUNTs?: string;
    PayRate?: number;
    PayRate_cur?: number;
    PayRate_cur_Date?: string;
    PayRate_last?: number;
    PayRate_last_Date?: string;
    PayRate_first?: number;
    PayRate_first_Date?: string;
    SinceLast_RateChg_Date?: string;
    SinceLast_RateChg?: number;
    SinceLast_RateChg_Text?: string;
    BurdenRate?: number;
    BurdenRate_cur?: number;
    BurdenRate_cur_Date?: string;
    BurdenRate_last?: number;
    BurdenRate_last_Date?: string;
    BurdenRate_first?: number;
    BurdenRate_first_Date?: string;
    BillRate?: number;
    BillRate_cur?: number;
    BillRate_cur_Date?: string;
    BillRate_last?: number;
    BillRate_last_Date?: string;
    BillRate_first?: number;
    BillRate_first_Date?: string;

    // Display Attributes
    ETHOSUserIdDisplay?: string;
    // Relations
}

export interface EthosJobEntity extends DwOrmData {
    // Attributes
    JobId?: number;
    JobNumberId?: number;
    JobEtcDateTime?: string;

    // Display Attributes
    JobIdDisplay?: string;
    JobNumberIdDisplay?: string;
    // Relations
    EthosJobSite? : EthosJobSiteEntity[];
    EthosJobSow? : EthosJobSowEntity[];
    EthosJobSiteJobId? : EthosJobSiteEntity;
    EthosJobNumberJobNumberId? : EthosJobNumberEntity[];
    EthosJobNumber? : EthosJobNumberEntity;
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    // Relations
    EthosJob? : EthosJobEntity[];
    EthosJobJobNumberId? : EthosJobEntity;
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;

    // Relations
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;

    // Relations
}

export interface EthosJobSiteEntity extends DwOrmData {
    // Attributes
    JobSiteId?: number;
    JobId?: number;
    SiteId?: number;
    IsDeleted?: boolean;
    LookUpKey?: string;
    SubJobNumber?: string;
    FullJobNumber?: string;

    // Display Attributes
    JobIdDisplay?: string;
    SiteIdDisplay?: string;
    // Relations
    EthosJobSow? : EthosJobSowEntity[];
    EthosJobJobId? : EthosJobEntity[];
    EthosJob? : EthosJobEntity;
}

export interface EthosJobSowEntity extends DwOrmData {
    // Attributes
    JobSowId?: number;
    SowId?: number;
    JobId?: number;
    JobSiteId?: number;

    // Display Attributes
    SowIdDisplay?: string;
    JobIdDisplay?: string;
    JobSiteIdDisplay?: string;
    // Relations
    EthosJobSite? : EthosJobSiteEntity;
    EthosJob? : EthosJobEntity;
}

export interface EthosWachterJobTitleEntity extends DwOrmData {
    // Attributes
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    WachterJobTitleDescription?: string;
    AxIntegrationId?: string;
    RowInsertDateTime?: string;

    // Relations
    NewJobTitleIdPayJobChange? : PayJobChangeEntity[];
}

export interface FieldEmployeesPayRateEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    PayRate?: number;
    Company?: string;

    // Relations
}

export interface PayJobChangeEntity extends DwOrmData {
    // Attributes
    PayJobChangeId?: number;
    EffectiveDate?: string;
    CurrentWage?: number;
    NewWage?: number;
    Notes?: string;
    IsPayChange?: boolean;
    IsOrganizationalChange?: boolean;
    EmployeeEthos_UserId?: number;
    NewManagerEthos_UserId?: number;
    PayChangeTypeCv?: number;
    StatusCv?: number;
    StatusAssignedToEthos_UserId?: number;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    NewJobTitleId?: number;
    WagePercentChange?: number;
    NewEthos_WachterTeamId?: number;
    RejectedNotes?: string;
    RejectedByEthos_UserId?: number;

    // Display Attributes
    EmployeeEthos_UserIdDisplay?: string;
    NewManagerEthos_UserIdDisplay?: string;
    PayChangeTypeCvDisplay?: string;
    StatusCvDisplay?: string;
    StatusAssignedToEthos_UserIdDisplay?: string;
    CreatedbyEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    NewJobTitleIdDisplay?: string;
    NewEthos_WachterTeamIdDisplay?: string;
    // Relations
    PayJobChangeEmail? : PayJobChangeEmailEntity[];
    NewJobTitleIdEthosWachterJobTitle? : EthosWachterJobTitleEntity;
    PayJobChangeUsersRead? : PayJobChangeUsersReadEntity[];
}

export interface PayJobChangeEmailEntity extends DwOrmData {
    // Attributes
    PayJobChangeEmail?: number;
    EmailId?: string;
    PayJobChangeId?: number;

    // Display Attributes
    PayJobChangeIdDisplay?: string;
    // Relations
    PayJobChange? : PayJobChangeEntity;
}

export interface PayJobChangeUsersReadEntity extends DwOrmData {
    // Attributes
    PayJobChangeUsersRead?: number;
    Ethos_UserId?: number;
    PayJobChangeId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    PayJobChangeIdDisplay?: string;
    // Relations
    PayJobChange? : PayJobChangeEntity;
}

export interface RoPayJobChangeSubordinatesEntity extends DwOrmData {
    // Attributes
    PayJobChangeId?: number;
    EmployeeEthos_UserId?: number;
    CreatedbyEthos_UserId?: number;
    EmployeeSupervisorUserId?: number;
    EmployeeSupervisorName?: string;
    EmployeeSupervisorDepth?: number;
    CreatedBySupervisorUserId?: number;
    CreatedBySupervisorName?: string;
    CreatedBySupervisorDepth?: number;

    // Relations
}



